var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('div',{class:_vm.b('container')},[_c('formalization-referrals',{ref:"formalizationReferrals",attrs:{"referrals":_vm.referrals,"requesting":_vm.requesting,"validable":""},on:{"create":args => _vm.$emit('create', args),"update":args => _vm.$emit('update', args),"validate":args => _vm.$emit('validate', args)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }